import { Flex, Heading, Tabs } from '@conteg/ui';
import { Container } from 'components/basic-layout';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { RoutePaths } from 'utils/routing/route-paths';

import { AuditView } from '../types';

export const AUDIT_TABS: { id: AuditView; path: string; titleKey: string }[] = [
  { id: 'point', titleKey: 'Events.Tabs.Point', path: RoutePaths.AuditPoint },
  {
    id: 'content',
    titleKey: 'Events.Tabs.Content',
    path: RoutePaths.AuditContent,
  },
  {
    id: 'courier',
    titleKey: 'Events.Tabs.Courier',
    path: RoutePaths.AuditCourier,
  },
  {
    id: 'contact',
    titleKey: 'Events.Tabs.Contact',
    path: RoutePaths.AuditContact,
  },
];

interface AuditViewLayoutProps {
  currentView: AuditView;
  children: React.ReactNode;
  title?: string;
}

/**
 * Common layout for all audit views with tab navigation
 * Used by Point, Content, Courier, and Contact views
 */
export function AuditViewLayout({
  currentView,
  children,
  title,
}: AuditViewLayoutProps) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const currentIndex = AUDIT_TABS.findIndex((tab) => tab.id === currentView);

  const handleTabChange = (index: number) => {
    const tab = AUDIT_TABS[index];
    if (tab) {
      navigate(tab.path);
    }
  };

  const translatedTabs = AUDIT_TABS.map(({ titleKey, ...rest }) => ({
    ...rest,
    title: t(titleKey),
  }));

  return (
    <Container>
      <Flex
        gap="4rem"
        flexDirection="row"
        alignItems="center"
        marginBottom="8rem"
        flexWrap="wrap"
      >
        <Heading variant="h1" title={title || t('Events.Title')} />
        <Tabs
          tabs={translatedTabs}
          selectedIndex={currentIndex}
          onIndexChange={handleTabChange}
          hasMarginBottom={false}
        />
      </Flex>

      {/* View Content */}
      {children}
    </Container>
  );
}
